import React, { useEffect, useRef } from 'react';
import './FaqDrawer.styles.css';
import FaqContentComponent from '@src/apps/FaqContent/FaqContentComponent';

interface FaqDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

export const FaqDrawer: React.FC<FaqDrawerProps> = ({ isOpen, onClose }) => {
  const drawerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
      window.dispatchEvent(new CustomEvent('faqDrawerOpened'));
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
      if (isOpen) {
        window.dispatchEvent(new CustomEvent('faqDrawerClosed'));
      }
    };
  }, [isOpen, onClose]);

  const handleOverlayClick = () => {
    onClose();
  };

  return (
    <div className={`faq-drawer-container ${isOpen ? 'open' : ''}`}>
      <div
        className={`overlay ${isOpen ? 'visible' : ''}`}
        onClick={handleOverlayClick}
        aria-hidden="true"
      />
      <div
        ref={drawerRef}
        className={`drawer-wrapper ${isOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="faq-drawer-title"
      >
        <div className="drawer-header">
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Close FAQ drawer"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h2 id="faq-drawer-title" className="drawer-title">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="drawer-content">
          <div className="faq-parcel-wrapper">
            <FaqContentComponent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqDrawer;
